import axios,{AxiosRequestConfig } from 'axios';
import { GetUserLocalStorage, GetOrganizationNameLocalStorage } from '../context/AuthProvider/util';
import { Api } from './api';
import { Contract } from '../model/ContractModel';
import { ContractBC } from '../model/ContractBCModel';
import { ICreditCardInformations } from '../pages/AdminConsole/AccountAndSubscription/AccountAndSubscription';


  export async function GetContract(idContractCockpit: string) {
    if (idContractCockpit === null) return null;
    const request = await Api.get<Contract>(
      "Contract/" + idContractCockpit
    );
  
  return request.data;
}

export async function GetContractBC(internalName: string) {
  const request = await Api.get<ContractBC>(
    "Organization/contractInformation/" + internalName
  );

  return request.data;
}